<style lang="scss">
    .checkout-item{
        .cart-row-beat-container{
            padding: 5px;
            padding-bottom: 0px;
            margin-left: 0px;
            margin-right: 0px;
            border-radius: 5px;

            .boxed{
                background-image: linear-gradient(135deg, #ff5b94 0%, #8441a4 100%);
                opacity: 0.6;
            }

            .divider{
                border-bottom: 1px solid;
                opacity: 0.36;
            }

            
            .shadow{
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                border: 0;
                border-radius: 5px;
                z-index: 1;
                opacity: 0;
                &.boxed {
                    background-image: linear-gradient(135deg, #8f40b0 0%, #642d7b 100%);
                    opacity: 0.6;
                }
            }

            .item-overlay{
                z-index : 3;
                position: inherit !important;
                .cart-row-beat-container:focus,
                .cart-row-beat-container:hover & {
                    opacity: 1;
                }
            }

            .item-media{
                box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.16);
                border-radius: 5px !important;
                height: 52px;
                width: 52px;
                min-width: 52px;
                overflow: inherit !important;
                margin-top: 10px;
                margin-bottom: 10px;
            }

            .sound-kit-title, .item-title {
                font-family: Poppins;
                font-weight: 400;
                font-size: 14px !important;
                background: none !important;
                text-overflow : ellipsis;
                margin-left: 10px;
                margin-top: 25px;
            }

            .row-btn-playpause {
                background: #fff;
                color: #8f40b0;
                position: absolute !important;
                top: 2px !important;
                left: 2px !important;
                padding: 0 0px !important;
            }

            .quarter {
                width: 15px;
                height: 14px;
                background-color: #ffffff;
                opacity: 0.52;
            }

            .top-right {
                border-top-right-radius: 24px;
                border-bottom-right-radius: 3px;
                border-top-left-radius: 3px;
                position: absolute;
                right: 0;
                top: 0;
            }

            .bottom-left {
                border-bottom-left-radius: 24px;
                position: absolute;
                border-top-left-radius: 3px;
                border-bottom-right-radius: 3px;
                bottom: 0;
                left: 0;
            }

            #circle-container {
                width: 30px;
                height: 30px;
                position: relative;
                z-index: 1;
            }

            .center{
                position: absolute;
                padding: 0 !important;
                top: 50%;
                left: 50%;
                margin-top: -15px;
                margin-left: -15px;
            }

            .item-text{
                font-family: Poppins;
                font-weight: 400;
                font-size: 14px;
                text-transform: uppercase;
                margin-top: 25px;
                cursor: pointer;
            }

            .tag-span{
                border-radius: 5px;
                border: 1px solid rgba(200, 200, 200, 0.4);
                height: 16px;
                color: #c8c8c8;
                font-family: Poppins;
                font-size: 8px;
                font-weight: 400;
                width: fit-content;
                padding: 2px;
                margin: 1px;
                display: inline-block;
            }

            .price{
                font-family: Poppins;
                font-size: 14px;
                font-weight: 400;
                margin-top: 25px;  
            }

            .item-media-colomn{
                display: flex;
                overflow: hidden;
                padding-left: 0px !important;
                padding-right: 0px !important;
            }

            .remove{
                margin-top: 30px !important;
                text-align: right;
                cursor: pointer;
                padding-right: 0px !important;
            }
        }

        .cart-row-beat-container:hover  {
            .item-overlay{
                opacity: 1 !important;
            }
        }

        .playing{
            background-color: #ffedf3;

            .item-overlay{
                opacity: 1 !important;
                display: block !important;
            }

            .tag-span{
                border: 1px solid #595e63 !important;
                color: #595e63 !important;
            }

        }
    }

    @media screen and (max-width: 768px) {
        .checkout-item{
            .sound-kit-title, .item-title{
                display: flex !important;
                flex-direction: column !important;
                font-size: 12px !important;
                font-weight: 600 !important;
            }

            .item-title{
                margin-top: 17px !important;
            }

            .item-text{
                margin-top: 0px !important;
                font-size: 11px !important;
                font-weight: 400 !important;
                text-transform: uppercase;
            }
        }
    }

    .hide-on-mobile {
        display: none;
    }  
    
    @media screen and (max-width: 500px) {
        .checkout-item{
            .sound-kit-title, .item-title{
                display: flex !important;
                flex-direction: column !important;
                font-size: 12px !important;
                font-weight: 600 !important;
            }

            .item-title{
                margin-top: 17px !important;
            }

            .item-text{
                margin-top: 0px  !important;
                font-size: 11px !important;
                font-weight: 400 !important;
                text-transform: uppercase;
            }
        }
    }
</style>

<template>
<div class="checkout-item">
    <div class="row cart-row-beat-container" @mouseover="hover(true)" @mouseleave="hover(false)" :style="hoverStyles" :class="{'active': active , 'playing' : isPlaying || isPaused}" >
        <div class="col d-flex flex-row item-media-colomn" :class="{'col-md-5 col-sm-8 col-xs-8': !cartPopup, 'col-md-9 col-sm-9 col-xs-9': cartPopup}">
            <div class="item-media" >
                <div class="shadow" :class="{'boxed': hovered || isPlaying || isPaused}" :style="$musicContainerOverlayStyle"></div>
                <div class="item-media-content" :style="{'background-image': 'url(' +  element.item.image(50) + ')'}"></div>
                <div class="item-overlay center">
                    <div id="circle-container">
                        <div class="quarter top-right" :style="$itemPlayButtonStyle"></div>
                        <div class="quarter bottom-left" :style="$itemPlayButtonStyle"></div>
                        <button v-if="isPlaying" class="row-btn-playpause" :style="$itemPlayButtonStyle" @click.stop="element.item.pause()">
                            <font-awesome-icon icon="pause"></font-awesome-icon>
                        </button>

                        <button v-else class="row-btn-playpause" :style="$itemPlayButtonStyle" @click="element.item.play()">
                            <font-awesome-icon icon="play"></font-awesome-icon>
                        </button>
                    </div>
                </div>
            </div>
            <div class="text-ellipsis" :class="{'item-title': !elementIsSoundkitOrSong, 'sound-kit-title' : elementIsSoundkitOrSong}">
                <router-link v-if="element.type == 'beat'" @click.native="closeModal()" :to="{name: 'beat', params: {beat: element.item.alias}}" :style="rowItemStyles">{{element.item.name}}</router-link>
                <router-link v-if="element.type == 'soundkit'" @click.native="closeModal()" :to="{name: 'soundkit', params: {soundkit: element.item.id}}" :style="rowItemStyles">{{element.item.name}}</router-link>
                <router-link v-if="element.type == 'song'" @click.native="closeModal()" :to="{name: 'song', params: {song: element.item.id}}" :style="rowItemStyles">{{element.item.name}}</router-link>
                <a v-if="element.type != 'soundkit' && element.type != 'song'" class="item-text hidden-md-up license-item" data-toggle="modal" href="#license-terms" @click="setModalLicense(element.license.id)">{{element.license.name}}</a>
            </div>
        </div>
        
        <div class="col hidden-sm-down col-md-4 item-text" :class="{'item-license-terms': cartPopup}">
            <a v-if="element.type != 'soundkit' && element.type != 'song'" data-toggle="modal" href="#license-terms" :style="$rowItemHighlightTextStyle" @click="setModalLicense(element.license.id)">{{element.license.name}}</a>
        </div>
        
        <div class="price" :class="{'col col-md-2 col-sm-3 col-xs-3': !cartPopup, 'sound-kit-price':  elementIsSoundkitOrSong}">
            {{element.price | displayPrice}}
        </div>

        <div class="col-md-1 col-sm-1 col-xs-1 remove pull-right" :class="{'hide-on-mobile': mobilePopupDisplayed}"  @click.stop="cart.removeItem(element)">
            <font-awesome-icon :icon="['fal','times']"></font-awesome-icon>
        </div>
        <div class="divider col-md-12 col-sm-12 col-xs-12" :style="$customBorderColor(0.3)"></div>
    </div>
</div>
</template>

<script>
    import CartItem from '../../classes/CartItem'
    import Beat from '../../models/beat'
    import Kit from '../../models/soundkit'
    import Playlist from './../../classes/playlist';
    import SoundKit from '../../models/soundkit';
    import Configure from './../../mixins/configure'
    export default {
        created() {
            this.$data.$display = "list"
        },
        data() {
            return {
                currentLicense: null,
                modalLicense: null,
            }
        },
        props:{
            element : Object,
            cartPopup: {
                type: Boolean,
                default: false
            }
        },
        mixins: [Configure],
		computed: {
            licenses() {
                return this.$store.getters.licenses
            },
            playlistManager() {
                return this.$store.state.playlistManager
            },
            active() {
                if (this.playlistManager.isPlaying(this.element.item)) {
                    this.$data.$active.musicContainer = true
                    return true
                }

                this.$data.$active.musicContainer = false
                return false
            },
            playerActive() {
                return this.$store.state.player.playing
            },
            isPlaying() {
                return (this.playlistManager.isPlaying(this.element.item) && this.playerActive)
            },
            isPaused() {
                return (this.playlistManager.isPlaying(this.element.item) && !this.playerActive)
            },
            hovered(){
                return this.$data.$hover.musicContainer;
            },
            cart(){
                return this.$store.state.cart
            },
            popupActive() {
                return this.$store.state.cartPopupClicked
            },
            hoverStyles() {
                if(!this.popupActive) {
                    return this.$cartRowItemStyle
                } 
            },
            rowItemStyles() {
                if (!this.popupActive) {
                    return this.$rowItemHighlightTextStyle
                }
            },
            elementIsSoundkitOrSong() {
                return this.element.type == 'soundkit' || this.element.type == 'song'
            },
            mobilePopupDisplayed() {
                if(this.cartPopup) {
                    if (window.innerWidth < 768 || window.innerHeight < 550) {
                        return true
                    }
                }

                return false
            }
        },
		methods: {
            setModalLicense: function(licenseId) {
                for (var i = 0; i < this.licenses.length; i++) {
                    if (this.licenses[i].id == licenseId) {
                        this.$store.commit('modalLicense', {modalLicense : this.licenses[i]});
                    }
                }
            },
            play(item){
                if(item.type == 'beat'){
                    let beat = new Beat(item.item);
                    beat.play();
                }
                if(item.type == 'soundkit'){
                    let kit = new SoundKit(item.item);
                    kit.play();
                }
            },
            hover(isHovering) {
                this.$data.$hover.musicContainer = isHovering
            },
            closeModal () {
                this.$store.commit('toggleCartPopupClick', false)
                $('#cartModal').modal('hide')
            }
        } 
    }
</script>